module.exports = __webpack_public_path__ + "img/vr2.4c0de8fe.jpg";